import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        recedeData: {},
        clickDevid: '',
        clickIndex: -1,
        clickParentIndex: -1,
        zoneid: '',
        // url: `http://47.97.60.182:9001/`,
        url: `https://flat.powerbee.cn/api/`,
        rechargeConfirm: false,
        rechargeDevice: {},
        deleteHid: '',
        treedata: '',
        selectedTreeNode: {},
        TreeNodeSelectInfo: {},
        treeZoneid: '',
        reportTableTabIndex: '1',
        abnormalTableTabIndex: '1',
        financeTableTabIndex:'1',
        preTable: 0,
        preAbnormalTabIndex: '',
        preReportTabIndex: '',
    },
    getters: {
        //修改日期格式
        getNowFormatDate: (state) => (dt) => {
            var date = dt;
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },

        //获取当前系统时间
        getNowFormatDateVal() {
            var date = new Date();
            var seperator1 = "-";
            var seperator2 = ":";
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
                + " " + date.getHours() + seperator2 + date.getMinutes()
                + seperator2 + date.getSeconds();
            return currentdate;
        },
    },
    mutations: {
        assignRecedeData(state, payload) {
            state.recedeData = payload
        },
        assignClickDevid(state, playload) {
            state.clickDevid = playload
        },
        assignClickIndex(state, playload) {
            state.clickIndex = playload
        },
        assignClickParentIndex(state, playload) {
            state.clickParentIndex = playload
        },
        assignGetZoneid(state, playload) {
            state.zoneid = playload
        },
        assignGetTreedata(state, playload) {
            state.treedata = playload
        },
        getRechargeDevice(state, playload) {
            state.rechargeDevice = playload;
        },
        changeRechargeStatus(state) {
            if (state.rechargeConfirm == true) {
                state.rechargeConfirm = false;
            } else {
                state.rechargeConfirm = true;
            }
        },
        assignDeleteHid(state, playload) {
            state.deleteHid = playload;
        },
        assignTreeNode(state, playload) {
            state.selectedTreeNode = playload;
        },
        assignTreeNodeSelectInfo(state, playload) {
            state.TreeNodeSelectInfo = playload;
        },
        assigntreeZoneid(state, playload) {
            state.treeZoneid = playload;
        },
        assignReportTableTabIndex(state, playload) {
            state.reportTableTabIndex = playload;
        },
        assignAbnormalTableTabIndex(state, playload) {
            state.abnormalTableTabIndex = playload;
        },
        assignAbnormalPreTableTab(state, playload) {
            state.preTable = playload.table;
            state.preAbnormalTabIndex = playload.index;
        },
        assignReportPreTableTab(state, playload) {
            state.preTable = playload.table;
            state.preReportTabIndex = playload.index;
        },
        assignFinanceTableTabIndex(state, playload){
            state.financeTableTabIndex = playload;
        }

    },
    actions: {}
})
